export * from './new-comunicacion-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/new-comunicacion-dialog/index.ts